import lottie from "lottie-web"
import acSingleMonthAnimation from "../../animations/ac-single-month-gift.json"

const animationsLoaders = {
  giftAnimation: () => {
    lottie.loadAnimation({
      container: document.querySelector("#gift-animation"),
      animationData: acSingleMonthAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
}

export default animationsLoaders;
